module.exports = __webpack_public_path__ + "static/img/bg-es.0f2761d7.png";